import { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import UserContext from 'src/contexts/user/UserContext';
import { PublicLayout } from 'src/layout';
import {
	AcceptInvitation,
	AppSumoOAuth,
	ForgotPassword,
	Login,
	PendingVerification,
	ResetPassword,
	SignUp,
	VerifyEmail,
} from 'src/pages';
import ScrappingPage from 'src/pages/scraping';
import authService from 'src/services/auth';
import { shouldShowPublicWebsite } from 'src/lib/utils/subdomain';
import { PublicWebsite } from 'src/pages/public-website';

const whiteListedRoutes = ['/verify-email'];

const getRoutesProtected = () => {
	const location = useLocation();
	const isAuth = authService.isAuthenticated();
	const { user } = useContext(UserContext);
	const isUserIncomplete = !user || user.permissions?.includes('demoByDomain');

	// If this is a public website subdomain, don't redirect to /home
	if (shouldShowPublicWebsite()) {
		return <Outlet />;
	}

	if (
		!isAuth ||
		whiteListedRoutes.includes(location.pathname) ||
		isUserIncomplete
	) {
		return <Outlet />;
	} else {
		return <Navigate to="/home" />;
	}
};

/**
 * Component to handle root path routing based on context
 */
const RootRedirect = () => {
	// If this is a public website subdomain, render the public website
	if (shouldShowPublicWebsite()) {
		return <PublicWebsite />;
	}
	
	// Otherwise, redirect based on auth status
	if (authService.isAuthenticated()) {
		return <Navigate to="/home" />;
	}
	
	return <Navigate to="/login" />;
};

const getPublicRoutes = () => ({
	element: <PublicLayout />,
	children: [
		{
			element: getRoutesProtected(),
			children: [
				{
					path: '/login',
					element: <Login />,
				},
				{
					path: '/signup',
					element: <SignUp />,
				},
				{
					path: '/forgot-password',
					element: <ForgotPassword />,
				},
				{
					path: '/reset-password',
					element: <ResetPassword />,
				},
				{
					path: '/invitation',
					element: <AcceptInvitation />,
				},
				{
					path: '/pending-verification',
					element: <PendingVerification />,
				},
				{
					path: '/app-sumo-oauth',
					element: <AppSumoOAuth />,
				},
				{
					path: '/',
					element: <RootRedirect />,
				},
			],
		},
		{
			path: '/verify-email',
			element: <VerifyEmail />,
		},
		{
			path: '/welcome/:id',
			// @ts-ignore
			element: <ScrappingPage />,
		},
	],
});

export default getPublicRoutes;
